import React from 'react';

import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';

import useGlobalStatus from '../hook/useGlobalStatus';
import Topbar from '../components/topbar/Topbar';
import LeftNav from '../components/leftnav/LeftNav';
import Copyright from '../components/copyright/Copyright';
import theme from '../theme';


const MainLayout = (props) => {
  const { drawerOpen } = useGlobalStatus();
  const isDesktop = useMediaQuery(theme.breakpoints.up('lg'));

  const contentLeft = () => {
    let marginLeft;
    if (drawerOpen && isDesktop) {
      marginLeft = '300px';
    } else if (!drawerOpen && isDesktop) {
      marginLeft = '60px';
    } else {
      marginLeft = 0;
    }
    return marginLeft;
  }

  const leftRight = isDesktop ? '12%' : '4%';

  return (
    <>
      <Topbar />

      <Box sx={{ position: 'relative', backgroundColor: theme.palette.grey.w50 }}>
        <LeftNav />

        <Box
          component="main"
          sx={{
            overflow: 'hidden',
            minHeight: '100vh',
            // marginLeft: contentLeft,
            padding: `60px ${leftRight} 32px`,
            transition: 'all .5s',
          }}
        >
          {props.children}
        </Box>

        <Copyright />

      </Box>
    </>
  );
}

export default MainLayout;